import React, { useMemo } from 'react';
import { CreditsEvolution } from '../../../graphql/credits';

export const formatCreditLoanLabel = (credit) => {
  if (!credit) return '';
  const bankId = String(credit.bankId ?? '').trim();
  const id = String(credit._id ?? '').trim();
  if (bankId && id) return `${bankId} · ${id}`;
  return id || bankId || '';
};

const CreditLoanDropdown = ({
  value,
  onChange,
  companyId,
  id,
  className = '',
  disabled = false,
  selectedTextOverride,
}) => {
  const { data, fetching } = CreditsEvolution(companyId);
  const credits = data?.Credits?.credits || [];

  const options = useMemo(() => {
    return [...credits]
      .sort((a, b) => {
        const da = a?.emision ? new Date(a.emision).getTime() : 0;
        const db = b?.emision ? new Date(b.emision).getTime() : 0;
        return db - da;
      })
      .map((credit) => ({
        value: String(credit._id),
        label: formatCreditLoanLabel(credit),
      }));
  }, [credits]);

  const handleChange = (e) => {
    const nextValue = e.target.value;
    const option = options.find((o) => o.value === nextValue);
    onChange?.(e, {
      value: nextValue,
      text: option?.label || selectedTextOverride || '',
    });
  };

  const displayOverride =
    value && selectedTextOverride && !options.some((o) => o.value === String(value))
      ? selectedTextOverride
      : null;

  return (
    <select
      id={id}
      className={`create-rule-select ${className}`.trim()}
      value={value || ''}
      onChange={handleChange}
      disabled={disabled || !companyId || fetching}
    >
      <option value="">
        {fetching ? 'Cargando préstamos...' : 'Seleccione préstamo bancario'}
      </option>
      {displayOverride && value ? (
        <option value={String(value)}>{displayOverride}</option>
      ) : null}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default CreditLoanDropdown;
